var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstravaNotext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.293606,
    height: 46.818844,
    viewBox: "0 0 41.293606 46.818844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 10.876512,28.111291 c 0.466464,4.605746 3.4134,10.96815 10.419002,10.96815 7.55716,0 9.397185,-6.818877 9.30348,-10.96815 0,0 -19.722482,0 -19.722482,0 z m 30.05329,-7.930268 c 0.182245,1.013548 0.363802,2.674429 0.363802,4.792475 0,9.865374 -4.791784,21.845347 -19.356616,21.845347 C 7.564052,46.818845 0,35.11448 0,22.672516 0,8.937265 8.574154,0 23.144151,0 c 6.450598,0 11.800483,1.1978605 15.66037,2.8542615 0,0 -1.655025,7.7431965 -1.655025,7.7431965 -3.50435,-1.1978601 -7.197838,-2.0267503 -12.440582,-2.0267503 -7.191639,0 -13.556794,3.5040073 -13.832402,11.6103153 0,0 30.05329,0 30.05329,0 z",
    fill: "#ed1c24",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.352778
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 24.833971,33.561086 c 0,1.958538 -1.59439,3.55086 -3.55224,3.55086 -1.961635,0 -3.552581,-1.592322 -3.552581,-3.55086 0,-1.959917 1.590946,-3.54948 3.552581,-3.54948 1.95785,0 3.55224,1.589563 3.55224,3.54948 z",
    fill: "#231f20",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.352778
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstravaNotext);
export default __webpack_public_path__ + "static/media/estrava_notext.48d18487b03b407ded87506943258216.svg";
export { ForwardRef as ReactComponent };